import { Meta, Story } from '@storybook/react';
import { Default as ConditionStepStory } from './ConditionStep/ConditionStep.stories';
import { Default as ResultStepStory } from './ResultStep/ResultStep.stories';
import { TravelDeduction, TravelDeductionProps } from './TravelDeduction';
import { Default as TravelStepStory } from './TravelStep/TravelStep.stories';
import { Default as YearStepStory } from './YearStep/YearStep.stories';
export default {
	title: 'Calculators/TravelDeduction',
	component: TravelDeduction,
} as Meta;

const Template: Story<TravelDeductionProps> = (args: TravelDeductionProps) => <TravelDeduction {...args} />;

export const Default: Story<TravelDeductionProps> = Template.bind({});
Default.args = {
	steps: ['Indledning', 'Kørsel', 'Særlige forhold', 'Resultat'],
	actions: {
		next: 'Næste',
		back: 'Tilbage',
		restart: 'Start forfra',
	},
	errorTexts: {
		submitFailed: 'Der skete en fejl',
		numberOfErrors: 'Antal fejl',
	},
	errorMessage: 'Påkrævet',
	units: {
		days: 'dage',
		kilometers: 'km',
	},
	...YearStepStory.args,
	...TravelStepStory.args,
	...ConditionStepStory.args,
	...ResultStepStory.args,
};
